/**
 * Curated category + location landing pages for aggregated white-collar jobs.
 *
 * These give the scraped/aggregated inventory real, crawlable, self-canonical
 * URLs with unique titles + original intro copy (so they aren't thin listing-only
 * pages). Individual aggregated jobs stay non-indexed and keep linking out
 * externally. Pure data (no React) so the Node sitemap script can import it too.
 */

export const LANDING_CITIES = [
  { slug: 'mumbai', label: 'Mumbai' },
  { slug: 'delhi-ncr', label: 'Delhi NCR' },
  { slug: 'bengaluru', label: 'Bengaluru' },
  { slug: 'hyderabad', label: 'Hyderabad' },
  { slug: 'pune', label: 'Pune' },
  { slug: 'chennai', label: 'Chennai' },
  { slug: 'kolkata', label: 'Kolkata' },
  { slug: 'ahmedabad', label: 'Ahmedabad' },
  { slug: 'gurgaon', label: 'Gurgaon' },
  { slug: 'noida', label: 'Noida' },
];

export const LANDING_CATEGORIES = [
  { slug: 'sales', label: 'Sales' },
  { slug: 'customer-support', label: 'Customer Support' },
  { slug: 'information-technology', label: 'Information Technology' },
  { slug: 'human-resources', label: 'Human Resources' },
  { slug: 'finance-accounting', label: 'Finance & Accounting' },
  { slug: 'marketing', label: 'Marketing' },
  { slug: 'operations', label: 'Operations' },
  { slug: 'engineering', label: 'Engineering' },
];

const slugMap = (list) => Object.fromEntries(list.map((x) => [x.slug, x.label]));
const CITY_BY_SLUG = slugMap(LANDING_CITIES);
const CATEGORY_BY_SLUG = slugMap(LANDING_CATEGORIES);

/** Title-case a slug as a fallback when it isn't in the curated list. */
export function deslugify(slug = '') {
  return String(slug)
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();
}

export function cityLabelFromSlug(slug) {
  return CITY_BY_SLUG[slug] || deslugify(slug);
}

export function categoryLabelFromSlug(slug) {
  return CATEGORY_BY_SLUG[slug] || deslugify(slug);
}

/** Original intro copy for a location landing page. */
export function locationIntro(cityLabel) {
  return {
    heading: `Jobs in ${cityLabel}`,
    body:
      `Browse current job openings in ${cityLabel} aggregated from across the web on JobxBharat. ` +
      `${cityLabel} employers hire across roles such as sales, customer support, IT, finance and operations — ` +
      `from entry-level and fresher positions to experienced and managerial roles. Use the filters to narrow by ` +
      `experience, job type and how recently a role was posted, then apply directly on the employer's site.`,
  };
}

/** Original intro copy for a category landing page. */
export function categoryIntro(categoryLabel) {
  return {
    heading: `${categoryLabel} Jobs in India`,
    body:
      `Explore ${categoryLabel} jobs across India, aggregated from multiple sources on JobxBharat. ` +
      `Roles in ${categoryLabel} span freshers to senior professionals across startups, mid-size firms and large ` +
      `enterprises in cities like Bengaluru, Mumbai, Delhi NCR, Hyderabad and Pune. Filter by location, experience ` +
      `and posted date to find the right fit, then apply on the employer's site.`,
  };
}
